import JsonApiResourceParser from './json-api-resource-serializer';

export default JsonApiResourceParser;
